// extracted by mini-css-extract-plugin
module.exports = {"toolgrid":"colorPicker_toolgrid__q_3LO"};